import { defineStore } from "pinia";
import { ApplicationScope, TermsConditions } from "~/api-client";
import { UploadUserFile } from "element-plus";

interface State{
    _allTermsAndConditions: TermsConditions[]
}
export const useTnCStore = defineStore('termsNConditions', {
    state: (): State => ({
        _allTermsAndConditions: [],
    }),

    getters: {
        allTermsAndConditions: (state) => state._allTermsAndConditions,
    },
    actions: {
        getTermsAndConditions() {
            const {$backendService  , $logger, $tenant} = useNuxtApp();
            return $backendService.termsConditionsControllerApi.getTermsAndConditions({
                xApplicationScope: $tenant.getTenant,
            }).then(result => {
                this.$state._allTermsAndConditions = result;
                return result;
            }).catch(err => {
                $logger.error("error fetching terms & conditions - ", err);
                ElMessage.error("Leider ist ein Fehler aufgetreten");
                throw err;
            });
        },
        getTermsAndConditionsById(id: string){
            const {$backendService  , $logger, $tenant} = useNuxtApp();
            return $backendService.termsConditionsControllerApi.getTermsAndConditionsById({
                xApplicationScope: $tenant.getTenant,
                id: id
            }).catch(error => {
                $logger.error('unable to download terms', error);
                ElMessage.error("Beim Herunterladen ist ein Fehler aufgetreten");
                throw error;
            })
        },
        async updateCurrentTermsAndConditions(file: UploadUserFile){
            const {$backendService  , $logger, $tenant} = useNuxtApp();

            $backendService.termsConditionsControllerApi.updateCurrentTermsAndConditions({
                xApplicationScope: ApplicationScope.MyDb,
                body: file.raw!
            }).then(result => {
                ElMessage.success('Die AGB wurden erfolgreich hochgeladen');
                return this.getTermsAndConditions();
            }).then(response => {
                this.$state._allTermsAndConditions = response;
            }).catch(error => {
                ElMessage.error('Beim Aktualisieren der AGB ist ein Fehler aufgetreten');
            })
        },
        getCurrentTermsAndConditions(){
            const {$backendService  , $logger, $tenant} = useNuxtApp();

            return $backendService.termsConditionsControllerApi.getCurrentTermsAndConditions({xApplicationScope: $tenant.getTenant}).catch(error => {
                $logger.error('unable to download terms', error);
                ElMessage.error("Beim Herunterladen ist ein Fehler aufgetreten");
                throw error;
            })
        }

    }
})